export default __webpack_public_path__ + "static/ak-cached/24h/media/Stream-TV.2d9b4b92.png";